import React from 'react'
import {
  Container,
  Icon,
  Image,
  ListContainer,
  Popup,
  TextBody
} from '@pdrj/pmi-iqos-ds-react'
import { Assets } from '@pdrj/pmi-iqos-shared-react'

const WheelPopupOverlayModal = ({
  isOpen,
  onClose,
  pointsLeft,
  children,
  type,
  showSpinWheelToolTip,
  POPUP_TYPE,
  mainBg,
  freeSpinBG
}) => {
  const POPUP_BG = {
    default_black: '#000000',
    transparent: 'rgba(0, 0, 0, 0.31)'
  }
  const bg =
    // if type is tooltip then background = black
    type === POPUP_TYPE.tooltip
      ? POPUP_BG.default_black
      : (type === POPUP_TYPE.loss_default || type === POPUP_TYPE.win) && mainBg // if win or loss after spin = same as main bg
      ? `url(${mainBg}) center / cover no-repeat`
      : type === POPUP_TYPE.free_spin_lost
      ? `url(${freeSpinBG}) center / cover no-repeat`
      : POPUP_BG.transparent

  return (
    <Popup
      isOpen={isOpen}
      blocking={true} // close is handled via custom header X
      backgroundStyle={bg}
      blurBackground={type === POPUP_TYPE.loss_onload}
      fullScreenMobile={true}
      fullScreen>
      {/* Top bar */}
      <Container additionalClasses="q-text-white" fullWidth pt="4">
        <ListContainer columns={3}>
          <Container
            display={Container.displays.flex}
            flexDirection={Container.flexDirections.row}>
            <Image src={Assets.urls.iconPoints} width="6" height="6" />
            <TextBody additionalClasses="q-text-white">{pointsLeft}</TextBody>
          </Container>

          <Container
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.center}>
            <Container onClickHandler={showSpinWheelToolTip}>
              <TextBody darkMode>
                <Icon size={Icon.sizes.s} image={Icon.images.info} />
              </TextBody>
            </Container>
          </Container>
          <Container
            display={Container.displays.flex}
            justifyContent={Container.justifyContentValues.end}>
            <Container onClickHandler={onClose}>
              <TextBody darkMode>
                <Icon size={Icon.sizes.s} image={Icon.images.cancel} />
              </TextBody>
            </Container>
          </Container>
        </ListContainer>
        <Container px="2" pt={['6', '8']}>
          {children}
        </Container>
      </Container>
      {/* Body */}
    </Popup>
  )
}
export default WheelPopupOverlayModal
